import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Login from './Components/Login';
import SignUp from './Components/SignUp';
import Calendario from './Components/Calendario';
import Navbar from './Components/Navbar';
import Servicios from './Components/Servicios';
import Clientes from './Components/Clientes';
import HorariosEmpleados from './Components/HorariosEmpleados';
import Empleados from './Components/Empleados';
import { ToastContainer } from 'react-toastify';
import Comisiones from './Components/Comisiones';
import DataList from './Components/DataList';
import { fetchWithAuth } from './utils/apiHelper';
import LiquidacionesResumen from './Components/LiquidacionesResumen';
import ConfirmarTurno from './Components/ConfirmarTurno';
import PaymentMethods from './Components/PaymentMethods';
import ArqueoCaja from './Components/ArqueoCaja';
import RetirosDinero from './Components/RetirosDinero';
import ClienteDetalles from './Components/ClienteDetalles';
import ServerInfo from './Components/ServerInfo';
import Estadisticas from './Components/Estadisticas';
import TurnosCancelados from './Components/TurnosCancelados';
import GiftCardDetail from './Components/GiftCardDetail';
import GiftCardManager from './GiftsCards/GiftCardManager';
import GiftCardsAdmin from './Components/GiftCardsAdmin';
import NotFound from './Components/NotFound';               // Para rutas inexistentes
import { Navigate } from 'react-router-dom';

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    verifyToken();
  }, []);


  function ProtectedRoute({ isAuthenticated, children }) {
    return isAuthenticated ? children : <Navigate to="/login" replace />;
  }

  const verifyToken = async () => {
    const token = localStorage.getItem('token');
    if (token) {
      try {
        const data = await fetchWithAuth('/auth/verify-token', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' }
        });
        if (data) {
          setIsAuthenticated(true);
        } else {
          console.error('Token inválido o expirado');
          setIsAuthenticated(false);
          localStorage.clear();
        }
      } catch (error) {
        console.error('Error al verificar el token:', error);
        setIsAuthenticated(false);
        localStorage.clear();
      }
    } else {
      setIsAuthenticated(false);
    }
    setLoading(false);
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-gradient-to-b from-pink-50 to-white">
        <div className="flex flex-col items-center space-y-2 animate-pulse">
          <div className="w-12 h-12 border-4 border-pink-300 border-t-transparent rounded-full animate-spin"></div>
          <p className="text-lg text-pink-700 font-semibold">Verificando acceso...</p>
        </div>
      </div>
    );
  }

  return (
    <Router>
      <div className="flex flex-col min-h-screen bg-gradient-to-b from-white-50 via-white to-pink-100 text-gray-800">
        <ToastContainer position="top-right" autoClose={1500} hideProgressBar={false} newestOnTop={false} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />

        {/* Sólo mostrar Navbar si está autenticado */}
        {isAuthenticated && <Navbar setIsAuthenticated={setIsAuthenticated} />}

        <div className="pt-10 w-full transition-opacity duration-500 ease-in-out opacity-100">
          <Routes>
            {/* Rutas públicas */}
            <Route path="/login" element={<Login setIsAuthenticated={setIsAuthenticated} />} />
            <Route path="/signup" element={<SignUp />} />
            <Route path="/gifts/cards/data/:id" element={<GiftCardDetail />} />
            <Route path="/confirmar/turno/:turno_id" element={<ConfirmarTurno />} />

            {/* Rutas privadas (requieren login) */}
            <Route
              path="/"
              element={
                <ProtectedRoute isAuthenticated={isAuthenticated}>
                  <Calendario />
                </ProtectedRoute>
              }
            />
            <Route
              path="/server-data"
              element={
                <ProtectedRoute isAuthenticated={isAuthenticated}>
                  <ServerInfo />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/gifts/cards"
              element={
                <ProtectedRoute isAuthenticated={isAuthenticated}>
                  <GiftCardsAdmin />
                </ProtectedRoute>
              }
            />
            <Route
              path="/gifts/cards"
              element={
                <ProtectedRoute isAuthenticated={isAuthenticated}>
                  <GiftCardManager />
                </ProtectedRoute>
              }
            />
            <Route
              path="/servicios"
              element={
                <ProtectedRoute isAuthenticated={isAuthenticated}>
                  <Servicios />
                </ProtectedRoute>
              }
            />
            <Route
              path="/turnos/cancelados"
              element={
                <ProtectedRoute isAuthenticated={isAuthenticated}>
                  <TurnosCancelados />
                </ProtectedRoute>
              }
            />
            <Route
              path="/estadisticas"
              element={
                <ProtectedRoute isAuthenticated={isAuthenticated}>
                  <Estadisticas />
                </ProtectedRoute>
              }
            />
            <Route
              path="/clientes"
              element={
                <ProtectedRoute isAuthenticated={isAuthenticated}>
                  <Clientes />
                </ProtectedRoute>
              }
            />
            <Route
              path="/gestion/horarios"
              element={
                <ProtectedRoute isAuthenticated={isAuthenticated}>
                  <HorariosEmpleados />
                </ProtectedRoute>
              }
            />
            <Route
              path="/caja/arqueo"
              element={
                <ProtectedRoute isAuthenticated={isAuthenticated}>
                  <ArqueoCaja />
                </ProtectedRoute>
              }
            />
            <Route
              path="/gestion/empleados"
              element={
                <ProtectedRoute isAuthenticated={isAuthenticated}>
                  <Empleados />
                </ProtectedRoute>
              }
            />
            <Route
              path="/gestion/metodos/pago"
              element={
                <ProtectedRoute isAuthenticated={isAuthenticated}>
                  <PaymentMethods />
                </ProtectedRoute>
              }
            />
            <Route
              path="/gestion/comisiones"
              element={
                <ProtectedRoute isAuthenticated={isAuthenticated}>
                  <Comisiones />
                </ProtectedRoute>
              }
            />
            <Route
              path="/trabajos/Caja"
              element={
                <ProtectedRoute isAuthenticated={isAuthenticated}>
                  <RetirosDinero />
                </ProtectedRoute>
              }
            />
            <Route
              path="/caja/fuerte"
              element={
                <ProtectedRoute isAuthenticated={isAuthenticated}>
                  <DataList />
                </ProtectedRoute>
              }
            />
            <Route
              path="/Gestion/liquidacion"
              element={
                <ProtectedRoute isAuthenticated={isAuthenticated}>
                  <LiquidacionesResumen />
                </ProtectedRoute>
              }
            />
            <Route
              path="/detalles/cliente/:id"
              element={
                <ProtectedRoute isAuthenticated={isAuthenticated}>
                  <ClienteDetalles />
                </ProtectedRoute>
              }
            />

            {/* Ruta comodín para no mostrar pantalla en blanco */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </div>
      </div>
    </Router>
  );
}

export default App;
